import { withSSR } from 'withSSR';
import { NextPage } from 'next';

import { ETickets } from 'components/ETickets/ETickets';
import { ApiKeyContext } from 'contexts/ApiKeyContext';
import { wrapper } from 'ducks';
import { bookingWidgetDomainUrlServerSidePropsGetter } from 'lib/util/bookingWidgetDomainUrlServerSidePropsGetter';

interface Props {
  apiKey: string;
  host: string;
}

const Page: NextPage<Props> = ({ apiKey, host }) => {
  return (
    <ApiKeyContext.Provider
      value={{
        apiKey,
        useApiKeyInPaths: false,
      }}
    >
      <ETickets host={host} />
    </ApiKeyContext.Provider>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async (props) => {
  const eTicketQrCodeId = props.query?.qrCodeId as string;

  return await bookingWidgetDomainUrlServerSidePropsGetter({
    loadAllLanguages: true,
    eTicketQrCodeId: eTicketQrCodeId,
  })(props);
});

export default withSSR()(Page);
